<script lang="ts">
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import WeatherStationCard from './WeatherStationCard.svelte';
	import CloudRainLight from './Icons/CloudRainLight.svelte';
	import DropletSlashIcon from './Icons/DropletSlashIcon.svelte';

	export let statuses;

	$: moistureAlarm = statuses.find((i) => i.name === 'moisture_alarm:0');
	$: rainfall = statuses.find((i) => i.name === 'precipitation:0')?.value || '--';
</script>

<WeatherStationCard
	on:click
	icon="fas fa-droplet"
	label={capFirstChar($format('opt_rain', { default: 'Rain' }))}
	value={moistureAlarm?.value}
	description={$format('weather_station_rainfall', {
		default: 'Past 24h rainfall',
	})}
	descriptionValue={rainfall}
>
	<div slot="main" class="d-flex">
		{#if moistureAlarm?.rawValue}
			<CloudRainLight />
		{:else}
			<DropletSlashIcon />
		{/if}
	</div>
</WeatherStationCard>
